import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo-white.png'
import _imports_1 from '@/assets/badges.png'


const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "lego",
  width: "160",
  class: "inline-block opacity-90 hover:opacity-100"
}, null, -1)
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "beian"
  }),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/",
    rel: "noreferrer",
    target: "_blank"
  }, " 赣ICP备2026000736号 ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-white flex mb-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-2 bg-yellow-500 rounded-l" }, "version"),
    /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-2 bg-blue-500 rounded-r" }, "1.0.0")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "建站日期：2024-09-25")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_user_profile = _resolveComponent("user-profile")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "bg-white min-h-screen" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, {
        class: _normalizeClass(["flex-center relative top-0 z-50", { 'transparent-header': _ctx.route.path === '/' }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              type: "primary",
              shape: "round",
              onClick: _ctx.goCreateWork
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 创建设计 ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              shape: "round",
              onClick: _ctx.goWorks
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 我的作品 ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_user_profile)
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_a_layout_content, {
        class: _normalizeClass({ 'home-layout': _ctx.route.path === '/' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_a_layout_footer, { class: "flex items-center justify-between py-4 px-10" }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}